import { RuleOutputPath } from '@decisions/server/DecisionsFramework/Design/Flow';
import { ValidationIssue } from '@decisions/server/DecisionsFramework/ValidationIssue';

export const RULE_ANCHOR_ERROR_VALIDATION_CODE = 1;
export const RULE_VERB_ERROR_VALIDATION_CODE = 2;
export const RULE_VALUE_ERROR_VALIDATION_CODE = 3;
export const RULE_OUTPUT_ERROR_VALIDATION_CODE = 4;

// TODO: ideally, we need to add "ValidationIssues" property to the "RuleOutputDisplayData" and send it from server,
// however it require a big refactoring to be made before it will be possible
export function getRuleOutputIssues(issues: ValidationIssue[], outputName: string, path: RuleOutputPath) {
  return (issues || []).filter(item => item.ReferenceProperty === getOutputReferenceName(outputName, path));
}

function getOutputReferenceName(outputName: string, path: RuleOutputPath): string {
  switch (path) {
    case RuleOutputPath.True:
      return `${outputName} [True]`;
    case RuleOutputPath.False:
      return `${outputName} [False]`;
    case RuleOutputPath.MissingData:
      return `${outputName} [MissingData]`;
  }
}

export function getVerbIssues(issues: ValidationIssue[]): ValidationIssue[] {
  return (issues || []).filter(issue => issue.ValidationCode === RULE_VERB_ERROR_VALIDATION_CODE);
}

export function getValueIssues(issues: ValidationIssue[]): ValidationIssue[] {
  return (issues || []).filter(issue => issue.ValidationCode === RULE_VALUE_ERROR_VALIDATION_CODE);
}
